<ng-container *ngIf="bankAccountFields && bankAccountFields.length > 0">
	<div class="form-section-title">Bank account fields</div>

	<div class="full-width o-grid-3">
		<ng-container [formGroup]="bankAccountForm">
			<input-wrapper [label]="'Bank Name'">
				<input
					id="bankNameInput"
					type="text"
					id="bankName"
					placeholder="Bank Name"
					formControlName="bankName"
				/>
				<div
					input-errors
					*ngIf="
						bankAccountForm.get('bankName')?.touched && bankAccountForm.get('bankName')?.errors?.required
					"
				>
					Bank Name is required
				</div>
			</input-wrapper>
			<input-wrapper
				*ngFor="let field of bankAccountFields"
				[label]="field.label"
				[icon]="field.unique ? 'vpn_key' : undefined"
			>
				<input
					id="{{ field.key }}"
					[type]="field.type"
					[placeholder]="field.name"
					[formControlName]="field.key"
				/>
				<div
					input-errors
					*ngIf="
						bankAccountForm.controls[field.key].touched &&
						bankAccountForm.controls[field.key].errors?.required
					"
				>
					{{ field.name }} is required
				</div>
				@if (field.rules.EXACT_LENGTH && (bankAccountForm.controls[field.key].errors?.minlength ||
				bankAccountForm.controls[field.key].errors?.maxlength)){
				<div input-errors>Must be exactly {{ field.rules.EXACT_LENGTH }} characters</div>
				} @if (!field.rules.EXACT_LENGTH && bankAccountForm.controls[field.key].errors?.minlength) {
				<div input-errors>Min length is {{ field.rules.MIN }}</div>
				} @if (!field.rules.EXACT_LENGTH && bankAccountForm.controls[field.key].errors?.maxlength) {
				<div input-errors>Max length is {{ field.rules.MAX }}</div>
				}
			</input-wrapper>
		</ng-container>
	</div>
</ng-container>
